module.exports = __webpack_public_path__ + "img/FFQS0317-02.494e8b55.jpg";